import React, { useState } from 'react';
import styled from 'styled-components';
import BaseButton from './BaseButton';

import { Colors } from '../../../../scss/common/style';

interface Props {
  size?: 'sm' | 'lg';
  onClick?: () => void;
  title?: string;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
}

export default function TertiaryButton({
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  type,
}: Props): JSX.Element {
  return (
    <StyledButton className="btn-secondary">
      <BaseButton
        type={type}
        title={title}
        onClick={onClick}
        isSubmitting={isSubmitting}
        disabled={disabled}
        active={active}
      />
    </StyledButton>
  );
}

const StyledButton = styled.div`
  background: transparent !important;
  button {
    background-color: #fff;
    color: ${Colors.newOrage};
    border: 2px solid ${Colors.newOrage};
    border-color: ${Colors.newOrage};
    &:hover {
      color: ${Colors.darkRed};
      border-color: ${Colors.darkRed};
      color: '#fff';
    }
    &:active {
      color: ${Colors.darkBrown};
      border-color: ${Colors.darkBrown};
    }
  }
`;
